export default __webpack_public_path__ + "static/media/dcf_formula.568e0fe7.svg";